module.exports = "/_next/static/resources/life2-4dc81f490b45cc0f77e3524a4d970b77.webp";